<template>
  <div
    class="print:hidden w-full pt-10 bg-stone-100 border-t border-stone-300 flex-col justify-start items-center inline-flex"
  >
    <div class="self-stretch px-4 flex-col justify-start items-start gap-7 flex">
      <div class="flex-col justify-start items-start gap-2 flex">
        <div
          class="text-stone-700 text-base font-semibold leading-none"
          @click="()=>$router.push({
            name: 'CustomerCenter'
          })"
        >
          Customer Service
        </div>
        <div class="flex-col justify-center items-start gap-3 flex">
          <div class="text-stone-700 text-4xl font-normal leading-10">
            1800-8914
          </div>
          <div class="flex-col justify-start items-start gap-1 flex">
            <div class="flex-col justify-center items-start gap-2 flex">
              <div class="text-stone-700 text-base font-semibold leading-none">
                {{ $t('평일') }} 10:00~18:00
              </div>
              <div class="text-stone-700 text-base font-normal leading-none">
                {{ $t("점심시간") }} 12:00~13:00
              </div>
              <div class="text-stone-700 text-base font-normal leading-none">
                {{ $t("주말, 공휴일 휴무") }}
              </div>
            </div>
            <div class="text-stone-700 text-base font-normal leading-none">
              service@candleworks.com
            </div>
          </div>
        </div>
      </div>
      <div class="flex-col justify-start items-start gap-2 flex">
        <div class="text-stone-700 text-base font-semibold leading-none">
          Bank Account
        </div>
        <div class="flex-col justify-start items-start gap-1 flex">
          <div class="text-stone-700 text-base font-normal leading-none">
            기업은행 614-020463-04-011
          </div>
          <div class="text-stone-700 text-base font-normal leading-none">
            크로마웍스 주식회사
          </div>
        </div>
      </div>
      <app-install-links />
      <div class="flex-col justify-start items-start gap-2 flex">
        <div
          class="pl-3.5 pr-2 py-0.5 rounded-full bg-stone-700 border border-stone-700 justify-end items-center gap-1 inline-flex"
        >
          <div class="justify-start items-center flex">
            <div
              class="text-center text-sm text-white font-medium leading-none"
              @click="()=>$router.push({
                name: 'OfflineStore'
              })"
            >
              {{ $t("CW 오프라인 매장 살펴보기") }}
            </div>
          </div>
          <div class="w-4 h-4 relative" />
        </div>
      </div>
      <div class="flex-col justify-start items-start gap-2 flex">
        <div class="justify-start items-center gap-3 flex w-full">
          <a
            href="http://pf.kakao.com/_qKnjxl"
            target="_blank"
            class="w-7 h-7 relative"
          >
            <img
              alt=""
              src="/images/icons/sns-kakao.svg"
            >
          </a>
          <a
            href="https://www.instagram.com/candleworks_"
            target="_blank"
            class="w-7 h-7 relative"
          >
            <img
              alt=""
              src="/images/icons/sns-insta.svg"
            >
          </a>
          <a
            href="https://www.instagram.com/chromaworks"
            target="_blank"
            class="text-sm py-0.5 px-3 border rounded-2xl border-stone-700 ml-auto"
          >
            @chromaworks
          </a>
        </div>
      </div>
      <insta-feeds />
    </div>
    <div class="self-stretch px-4 pt-10 pb-3 flex-col justify-start items-start flex">
      <div class="self-stretch py-4 border-t border-stone-300 flex-col justify-start items-start flex">
        <div
          class="self-stretch justify-start items-center gap-3 inline-flex"
          @click="$router.push({
            name:'CustomerNotice'
          })"
        >
          <div class="grow shrink basis-0 text-stone-700 text-base font-semibold leading-none">
            {{ $t("공지사항") }}
          </div>
          <img
            src="/images/icons/plus.svg"
            class="w-3.5 h-3.5 relative"
          >
        </div>
      </div>
      <div class="self-stretch flex-col justify-start items-start flex">
        <div
          class="self-stretch h-12 py-4 border-t border-stone-300 flex-col justify-start items-start gap-3 flex"
          @click="$router.push({
            name: 'MyPage'
          })"
        >
          <div class="self-stretch justify-start items-start gap-3 inline-flex">
            <div class="grow shrink basis-0 text-stone-700 text-base font-semibold leading-none">
              {{ $t("마이페이지") }}
            </div>
            <img
              alt=""
              src="/images/icons/plus.svg"
              class="w-3.5 h-3.5 relative"
            >
          </div>
        </div>
        <div
          class="self-stretch h-12 py-4 border-t border-stone-300 flex-col justify-start items-start gap-3 flex"
          @click="()=>{$router.push({
            name: 'CustomerCenter'
          })}"
        >
          <div class="self-stretch justify-start items-start gap-3 inline-flex">
            <div
              class="grow shrink basis-0 text-stone-700 text-base font-semibold leading-none"
              @click="()=>$router.push({
                name: 'CustomerCenter'
              })"
            >
              {{ $t("고객센터") }}
            </div>
            <img
              alt=""
              src="/images/icons/plus.svg"
              class="w-3.5 h-3.5 relative"
            >
          </div>
        </div>
        <div
          v-if="showEasycationInspectionMenu"
          class="self-stretch h-12 py-4 border-t border-stone-300 flex-col justify-start items-start gap-3 flex"
        >
          <a
            :href="EASYCATION_INSPECTION_REQUEST_URL"
            target="_blank"
            rel="noopener noreferrer"
            class="self-stretch justify-start items-start gap-3 inline-flex"
          >
            <div class="grow shrink basis-0 text-stone-700 text-base font-semibold leading-none">
              {{ $t("시험검사 의뢰하기") }}
            </div>
            <img
              alt=""
              src="/images/icons/plus.svg"
              class="w-3.5 h-3.5 relative"
            >
          </a>
        </div>
        <div
          class="self-stretch h-12 py-4 border-t border-stone-300 flex-col justify-start items-start gap-3 flex"
          @click.stop="()=>{$router.push({
            name: 'ManufacturingInquiryBoard'
          })}"
        >
          <div class="self-stretch justify-start items-start gap-3 inline-flex">
            <div
              class="grow shrink basis-0 text-stone-700 text-base font-semibold leading-none"
              @click.stop="()=>$router.push({
                name: 'ManufacturingInquiryBoard'
              })"
            >
              {{ $t("제조상담문의") }}
            </div>
            <img
              alt=""
              src="/images/icons/plus.svg"
              class="w-3.5 h-3.5 relative"
            >
          </div>
        </div>
        <div
          class="self-stretch h-12 py-4 border-t border-stone-300 flex-col justify-start items-start gap-3 flex"
          @click.stop="()=>{$router.push({
            name: 'ShipmentCostPage'
          })}"
        >
          <div class="self-stretch justify-start items-start gap-3 inline-flex">
            <div
              class="grow shrink basis-0 text-stone-700 text-base font-semibold leading-none"
              @click.stop="()=>$router.push({
                name: 'ShipmentCostPage'
              })"
            >
              {{ $t("해외 배송료 안내") }}
            </div>
            <img
              alt=""
              src="/images/icons/plus.svg"
              class="w-3.5 h-3.5 relative"
            >
          </div>
        </div>
        <div class="self-stretch h-12 py-4 border-t border-stone-300 flex-col justify-start items-start gap-3 flex">
          <div
            class="self-stretch justify-start items-start gap-3 inline-flex"
            @click="$router.push({
              name: 'Company'
            })"
          >
            <div class="grow shrink basis-0 text-stone-700 text-base font-semibold leading-none">
              {{ $t('회사소개') }}
            </div>
            <img
              alt=""
              src="/images/icons/plus.svg"
              class="w-3.5 h-3.5 relative"
            >
          </div>
        </div>
      </div>
    </div>
    <div class="w-full px-4 py-6 bg-gray-200 justify-start items-start gap-3 flex">
      <div class="justify-start items-start gap-1 flex flex-wrap">
        <div class="footer-info-text">
          상호명: 크로마웍스 주식회사
        </div>
        <div class="footer-info-text">
          사업자등록번호: 130-87-01811
        </div>
        <div class="px-1 py-0.5 bg-stone-500 rounded-sm justify-end items-center flex">
          <a
            href="https://mob.tbht.hometax.go.kr/jsonAction.do?actionId=UTBABAAA14F001&menuId=6001150200"
            target="_blank"
            class="text-center text-stone-100 text-xs font-medium leading-3"
          >
            사업자정보확인
          </a>
        </div>
        <div class="footer-info-text">
          통신판매업신고: 제2014-경기부천-1610호
        </div>
        <div class="footer-info-text">
          대표자: 장혜경
        </div>
        <div class="footer-info-text">
          개인정보책임자: 김경철
        </div>
        <div class="justify-start items-start gap-1 flex flex-wrap">
          <div class="footer-info-text">
            사업장소재지: 경기도 부천시 산업로 120 캔들웍스하우스
          </div>
          <div class="footer-info-text">
            {{ $t("고객센터") }}:<a href="tel:18008914">1800-8914</a> / 032-672-8914
            ({{ $t("토/일/공휴일 휴무") }})
          </div>
          <div class="text-stone-700 text-xs font-medium leading-3">
            service@chromaworks.co.kr
          </div>
        </div>
        <div class="self-stretch text-stone-700 text-xs font-medium leading-3">
          © 2007 - {{ new Date().getFullYear() }} CW Inc., All Rights
          Reserved.
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>

import {onMounted, onUnmounted, ref} from "vue";
import InstaFeeds from "@/components/ui/InstaFeeds.vue";
import AppInstallLinks from "@/components/ui/AppInstallLinks.vue";
import {
  EASYCATION_INSPECTION_REQUEST_URL,
  isEasycationInspectionMenuVisible,
  scheduleEasycationInspectionMenuVisibility
} from "@/utils/easycationInspectionMenu.js";

const showEasycationInspectionMenu = ref(isEasycationInspectionMenuVisible());
let stopEasycationMenuTimer = () => {};

onMounted(() => {
  stopEasycationMenuTimer = scheduleEasycationInspectionMenuVisibility((visible) => {
    showEasycationInspectionMenu.value = visible;
  });
});

onUnmounted(() => {
  stopEasycationMenuTimer();
});
</script>
<style scoped>
.menu-icons img {
  cursor: pointer;
}

.footer-info-text {
  @apply text-stone-700 text-xs font-medium leading-3
}
</style>
